/* eslint-disable camelcase */
import { put, select, delay } from 'redux-saga/effects';
import {
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
} from '../actions/actionTypes';
import {
    convertObjectToQueryParams,
    generate_UUID,
    limitQuantityTo50,
} from 'src/utils/util';
import { setCartData } from 'src/pages/consignmentAdd/redux/actions';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { filterProductsWithQuantityGreaterThanZero } from 'src/utils/util';
import { getconsignmentAddValidateProductsDataServices } from 'src/pages/consignmentAdd/services';

const validateResponse = (response) => {
    if (Array.isArray(response)) {
        if (
            response[0].statusCode === '11000' ||
            response[0].statusCode === '11001'
        )
            return true;
    }
    if (response.statusCode === '10501') {
        return false;
    }
};

const validateTissueAndNonTissueSalesOrgs = (
    { products, orderType },
    soldToAccount,
    accountName,
    physicianId,
    physicianDisplayName
) => {
    /*const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/validateproduct?`;*/

    // const tissueSalesOrg = [];
    // const nonTissueSalesOrg = [];
    // const otherSalesOrg = [];
    // const otherSalesOrgItems = [];
    const promiseArray = [];
    const groupProductsBySalesOrg = products.reduce((prev, curr) => {
        prev[curr.salesOrg] = prev[curr.salesOrg] || [];
        prev[curr.salesOrg].push(curr.cfn || curr.productCFN);
        return prev;
    }, {});
    // products.forEach((product) => {
    //     if (product.salesOrg === TISSUE_AND_NON_TISSUE_SALES_ORG.tissue)
    //         tissueSalesOrg.push(product.cfn);
    //         else if (product.salesOrg === TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue)
    //         nonTissueSalesOrg.push(product.cfn || product.productCFN);
    //     else {
    //         otherSalesOrgItems.push(product.cfn || product.productCFN);
    //         otherSalesOrg.push(product.salesOrg);
    //     }
    // });

    /*if (tissueSalesOrg.length > 0) {
        const tissueUrl = `${url}${convertObjectToQueryParams({
            productCFN: tissueSalesOrg.join(),
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
            soldToAccount,
            orderType,
        })}`;*/

    /*  const tissuePromise = axios
            .get(tissueUrl)
            .then((response) => response.data);
        promiseArray.push(tissuePromise);*/

    Object.keys(groupProductsBySalesOrg).map((salesOrg) => {
        const salesOrgPromise = getconsignmentAddValidateProductsDataServices(
            convertObjectToQueryParams({
                productCFN: groupProductsBySalesOrg[salesOrg].join(),
                salesOrg: salesOrg,
                accountNo: soldToAccount,
                physicianId: physicianId,
                accountName: accountName,
                physicianName: physicianDisplayName,
                soldToAccount,
                orderType,
            })
        );
        promiseArray.push(salesOrgPromise);
    });

    // if (tissueSalesOrg.length > 0) {
    //     const tissuePromise = getconsignmentAddValidateProductsDataServices(
    //         convertObjectToQueryParams({
    //             productCFN: tissueSalesOrg.join(),
    //             salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
    //             soldToAccount,
    //             orderType,
    //         })
    //     );

    //     promiseArray.push(tissuePromise);
    // }

    /*if (nonTissueSalesOrg.length > 0) {
        const nonTissueUrl = `${url}${convertObjectToQueryParams({
            productCFN: nonTissueSalesOrg.join(),
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
            soldToAccount,
            orderType,
        })}`;*/

    /*const nonTissuePromise = axios
            .get(nonTissueUrl)
            .then((response) => response.data);
        promiseArray.push(nonTissuePromise);*/

    // if (nonTissueSalesOrg.length > 0) {
    //     const nonTissuePromise = getconsignmentAddValidateProductsDataServices(
    //         convertObjectToQueryParams({
    //             productCFN: nonTissueSalesOrg.join(),
    //             salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
    //             soldToAccount,
    //             orderType,
    //         })
    //     );
    //     promiseArray.push(nonTissuePromise);
    // }

    // const getProductsPrice = getPricesForItemsDataService(
    //     convertObjectToQueryParams({
    //         productCFN: nonTissueSalesOrg.join(),
    //         sapPartnerId: soldToAccount,
    //         orderType,
    //     })
    // );
    // productsPrice.push(getProductsPrice);
    // const allPromise = Promise.all([promiseArray, productsPrice]);
    // return allPromise;
    return Promise.all(promiseArray);
};

export default function* validateProducts(action) {
    const { soldToAccount, inventoryShipping, accountName, physicianId, physicianDisplayName } = yield select((state) => ({
        soldToAccount:
            state.consignmentAddReducer.consignmentAddDetails?.accountId
                ?.accountId,
        inventoryShipping:
            state.consignmentAddReducer.consignmentAddDetails.inventoryShipping,
        accountName: state.consignmentAddReducer.consignmentAddDetails.accountId.accountName,
        physicianId: state.consignmentAddReducer.consignmentAddDetails.physicianId,
        physicianDisplayName: state.consignmentAddReducer.consignmentAddDetails.physicianDisplayName
    }));
    const { searchType } = action?.payload || {};
    try {
        let result = [];
        let results = [];
        var productsPrice = [];
        var productsPriceResults = [];
        var accountError = null;
        var surgeonError = null;
        results = yield validateTissueAndNonTissueSalesOrgs(
            action.payload,
            soldToAccount,
            accountName,
            physicianId,
            physicianDisplayName
        );
        // const productsDetailsresults =
        //     yield validateTissueAndNonTissueSalesOrgs(
        //         action.payload,
        //         soldToAccount
        //     );
        // results.push(
        //     yield productsDetailsresults[0][0].then((count) =>
        //         Object.assign({}, count)
        //     )
        // );
        // productsPrice.push(
        //     yield productsDetailsresults[1][0].then((count) =>
        //         Object.assign({}, count)
        //     )
        // );
        results.forEach(({ products = [], surgeonValidationErrorResponse }) => {
            result = [...result, ...products];
            accountError = surgeonValidationErrorResponse?.errors?.filter(
                (msg) => msg.statusCode === '11001'
            );
            surgeonError = surgeonValidationErrorResponse?.errors?.filter(
                (msg) => msg.statusCode === '11000'
            );
        });
        if (
            result.length === 0 &&
            (accountError?.length > 0 || surgeonError?.length > 0)
        ) {
            yield put({
                type: VALIDATE_PRODUCTS_SUCCESS,
                validatedProducts: [],
                accountError: accountError,
                surgeonError: surgeonError,
            });
            return;
        } else {
            productsPrice.forEach(({ priceDetails }) => {
                productsPriceResults = [
                    ...productsPriceResults,
                    ...priceDetails,
                ];
            });

            const { products } = action.payload;
            const productsForValidation = [];
            products.forEach((product) => {
                const index = productsForValidation.findIndex(
                    (item) => item.cfn === product.cfn
                );
                if (index === -1) {
                    productsForValidation.push({
                        ...product,
                        quantity: Number(product.quantity),
                    });
                } else {
                    productsForValidation[index].quantity =
                        productsForValidation[index].quantity +
                        Number(product.quantity);
                }
            });
            const validatedProducts = result;
            const productsToBeAddedToCart = [];
            let validatedProductIndex = 0;

            // calculating products to be added to cart and adding description
            validatedProducts.forEach((validatedProduct) => {
                validatedProductIndex = productsForValidation.findIndex(
                    (product) => product.cfn === validatedProduct.productCFN
                );
                validatedProduct.description = !action?.payload?.addItemRule
                    ? productsForValidation[validatedProductIndex].description
                    : validatedProduct.description;
                validatedProduct.salesOrg = !action?.payload?.addItemRule
                    ? productsForValidation[validatedProductIndex].salesOrg
                    : validatedProduct.salesOrg;
                validatedProduct.isSet = !action?.payload?.addItemRule
                    ? productsForValidation[validatedProductIndex].isSet
                    : validatedProduct.isSet;
                validatedProduct.implantable= validatedProducts[validatedProductIndex]?.implantable;
                validatedProduct.instrument= validatedProducts[validatedProductIndex]?.instrument;
                // validatedProduct.basePrice =
                //     productsPriceResults[validatedProductIndexValue].basePrice;

                if (
                    !validatedProduct.isExcluded &&
                    !validatedProduct.isExcludedExtraItem
                    // && !(
                    //     (inventoryShipping &&
                    //         productsForValidation[validatedProductIndex]
                    //             .salesOrg ===
                    //             TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                    //     (inventoryShipping &&
                    //         !productsForValidation[validatedProductIndex].isSet)
                    // )
                ) {
                    if (action.payload.addItemRule) {
                        productsForValidation[validatedProductIndex] = {
                            ...productsForValidation[validatedProductIndex],
                            description: validatedProduct.description,
                            isSet: validatedProduct.isSet,
                            uom: validatedProduct.uom,
                        };
                    }

                    productsToBeAddedToCart.push({
                        ...productsForValidation[validatedProductIndex],
                        quantity: productsForValidation[validatedProductIndex]
                            .quantity
                            ? productsForValidation[validatedProductIndex]
                                  .quantity
                            : 1,
                        isProductFamily:
                            validatedProduct?.productFamily !== '' &&
                            validatedProduct?.productFamily?.split(',')
                                ?.length > 0
                                ? true
                                : false,
                        productFamily:
                            validatedProduct?.productFamily !== '' &&
                            validatedProduct?.productFamily?.split(',')
                                ?.length > 0
                                ? validatedProduct?.productFamily?.split(',')
                                : [],
                        addItemRules:
                            validatedProduct?.addItemRules?.length > 0
                                ? validatedProduct?.addItemRules
                                : [],
                        businessRules:
                            validatedProduct?.businessRules?.length > 0
                                ? validatedProduct?.businessRules
                                : [],
                        implantable: validatedProduct?.implantable,
                        instrument: validatedProduct?.instrument,
                    });
                }
            });

            yield put({
                type: VALIDATE_PRODUCTS_SUCCESS,
                validatedProducts: validatedProducts.map((product) => ({
                    ...product,
                    productAdded:
                        searchType === 'productSearch' &&
                        productsToBeAddedToCart.length === 1,
                    nonInventoryShipping:
                        !product.isExcluded && !product.isExcludedExtraItem
                            ? (inventoryShipping &&
                                  product.salesOrg ===
                                      TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                              (inventoryShipping && !product.isSet)
                            : false,
                    productFamily: result[0].productFamily
                        ? result[0].productFamily.split(',')
                        : [],
                    basePrice: product.basePrice,
                    implantable: product?.implantable,
                    instrument: product?.implantable
                })),
                statusCode: results[0].statusCode,
                statusMessage: results[0].statusMessage,
            });

            // Logic for stopping duplicate entry
            const existingProducts = yield select(
                (state) => state.consignmentAddReducer.cartData.products
            );
            const clonedExistingProducts = [
                ...filterProductsWithQuantityGreaterThanZero(existingProducts),
            ];
            productsToBeAddedToCart.forEach((product) => {
                product.quantity = +product.quantity;
                const productIndex = clonedExistingProducts.findIndex(
                    (item) => item.productCFN === product.cfn
                );
                product.productCFN = product.cfn;
                // eslint-disable-next-line no-self-assign
                product.implantable= product?.implantable;
                 // eslint-disable-next-line no-self-assign
                product.instrument= product?.instrument;
                // clonedExistingProducts[productIndex].basePrice =
                //     productsPriceResults.length > 0
                //         ? productsPriceResults[productPriceIndex].basePrice
                //         : 0;
                // delete product.cfn;
                if (action.payload.addItemRule === true) {
                    product.isAddItemRuleProduct = true;
                }
                if (product.salesOrg === 'S002')
                    product.shippingRequirement = true;
                // product.batchParked = false;
                if (productIndex !== -1 && !product.isSet) {
                    const index = clonedExistingProducts.some((item) => {
                        if (item.productCFN == product.productCFN) {
                            return true;
                        }
                    }); 
                    if (index && product.materialType == 'ZKMT') {
                        // const prod = clonedExistingProducts.filter(
                        //     (item) => product.productCFN === item.productCFN
                        // );

                        // const existingQuantity =
                        //     product.materialType === 'ZKMT' && prod.length > 0
                        //         ? prod.reduce(
                        //               (prev, current) =>
                        //                   prev + parseInt(current.quantity),
                        //               0
                        //           )
                        //         : 0;

                        // if (parseInt(existingQuantity) < 50) {
                        clonedExistingProducts.push({
                            ...product,
                            productKey: generate_UUID(),
                        });
                        // }
                    } else {
                        const quantity = limitQuantityTo50(
                            parseInt(
                                clonedExistingProducts[productIndex].quantity
                            ) + parseInt(product.quantity)
                        );

                        clonedExistingProducts[productIndex].quantity =
                            quantity;
                    }
                } else if (productIndex === -1 && !product.isSet) {
                    clonedExistingProducts.push({
                        ...product,
                        productKey: generate_UUID(),
                    });
                } else {
                    for (let i = 1; i <= Number(product.quantity); i++) {
                        let productModified = {
                            ...product,
                            productKey: generate_UUID(),
                            quantity: 1,
                        };
                        clonedExistingProducts.push(productModified);
                    }
                }
            });
            // updating cart data
            if (!action.payload.productType) {
                yield put(
                    setCartData({
                        products: clonedExistingProducts,
                        getPricesForItems: clonedExistingProducts,
                    })
                );
            }

            // Added a delay of 1200ms for showing added and tick mark in ui
            // this will re-render the ui with productAdded as false, so tick mark will disapper after 1200ms
            if (
                searchType === 'productSearch' &&
                productsToBeAddedToCart.length === 1
            ) {
                yield delay(1500);

                yield put({
                    type: VALIDATE_PRODUCTS_SUCCESS,
                    validatedProducts: [
                        {
                            productCFN: result[0].productCFN,
                            productAdded: false,
                            isExcluded: result[0].isExcluded,
                            productFamily: result[0].productFamily
                                ? result[0].productFamily.split(',')
                                : [],
                        },
                    ],
                    statusCode: results[0].statusCode,
                    statusMessage: results[0].statusMessage,
                });
            }
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/products/validateproduct`,
            requestPayload: action.payload
        });
        yield put({
            type: VALIDATE_PRODUCTS_FAILURE,
            statusCode: e?.response
                ? e?.response?.data.statusCode
                : errorHandler('503'),
            statusMessage: e?.response
                ? e?.response?.data.statusDescription
                : e.Error,
        });
    }
}
